// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__oXepC","icon":"style_icon__2DEWI","title":"style_title__2sBx8"};